import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import Layout from "app/components/layouts";
import SelectLoanTypes from "app/components/loneTypes/SelectLoanTypes";
import PurposeOfLoan from "app/components/loneTypes/PurposeOfLoan";
import ConditionAndPurchase from "app/components/loneTypes/ConditionAndPurchase";
import FinancingTenure from "app/components/loneTypes/FinancingTenure";
import SelectCarBrand from "app/components/loneTypes/SelectCarBrand";
import TypeOfApplication from "app/components/loneTypes/TypeOfApplication";
import SelectModel from "app/components/loneTypes/SelectModel";
import PersonalDetailsPartOne from "app/components/loneTypes/PersonalDetailsPartOne";
import PersonalDetailsPartTwo from "app/components/loneTypes/PersonalDetailsPartTwo";
import EmploymentDetails from "app/components/loneTypes/EmploymentDetails";
import Liabilities from "app/components/loneTypes/Liabilities";
import Expenses from "app/components/loneTypes/Expenses";
import Summary from "app/components/loneTypes/Summary";
import VerifyApplication from "app/components/loneTypes/VerifyApplication";
import SecureYourAccount from "app/components/loneTypes/SecureYourAccount";
import PreQualified from "app/components/loneTypes/PreQualified";
import Declined from "app/components/loneTypes/Declined";
import OTP from "app/components/loneTypes/OTP";
import VinPlateNumber from "app/components/loneTypes/VinPlateNumber";
import PersonalDetailsSetpOne from "app/components/loneTypes/jointApplication/PersonalDetailsSetpOne";
import PersonalDetailsSetpTwo from "app/components/loneTypes/jointApplication/PersonalDetailsSetpTwo";
import JointLiabilities from "app/components/loneTypes/jointApplication/Liabilities";
import JointExpences from "app/components/loneTypes/jointApplication/Expences";
import EmploymentDetailsPartOne from "app/components/loneTypes/jointApplication/EmploymentDetailsPartOne";
import { StepsComponent } from "app/utils/types";

const SelectLoanType: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.loanTypesSteps.currentStep
  );

  const currentData = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const isRefinance = useMemo(() => {
    return currentData?.vehicleDetail?.purchaseFrom === "Refinance";
  }, [currentData]);
  const steps = useMemo<StepsComponent[]>(
    () => [
      <SelectLoanTypes key="select-loan-types" />,
      <PurposeOfLoan key="purpose-of-loan" />,
      <ConditionAndPurchase key="condition-and-purchase" />,
      <SelectCarBrand key="select-car-brand" />,
      <SelectModel key="select-model" />,
      ...(isRefinance ? [<VinPlateNumber key="vin-plate-number" />] : []),
      <FinancingTenure key="financing-tenure" />,
      <TypeOfApplication key="type-of-application" />,
      <PersonalDetailsPartOne key="personal-details-1" />,
      <PersonalDetailsPartTwo key="personal-details-2" />,
      <EmploymentDetails key="employment-details" />,
      <Expenses key="expenses" />,
      <Liabilities key="liabilities" />,
      <Summary key="summary" />,
      <SecureYourAccount key="secure-account" />,
      <OTP key="otp" />,
      <PreQualified key="pre-qualified" />,
      <VerifyApplication key="verify-application" />,
      <Declined key="declined" />,
      <PersonalDetailsSetpOne key="joint-personal-details-1" />,
      <PersonalDetailsSetpTwo key="joint-personal-details-2" />,
      <EmploymentDetailsPartOne key="joint-employment-details" />,
      <JointExpences key="joint-expences" />,
      <JointLiabilities key="joint-liabilities" />,
    ],
    [isRefinance]
  );

  const renderStep = useMemo(() => {
    if (currentStep >= 0 && currentStep < steps.length) {
      return steps[currentStep];
    }
    return <SelectLoanTypes />;
  }, [currentStep, steps]);

  return (
    <>
      <Layout>{renderStep}</Layout>
    </>
  );
};

export default SelectLoanType;
